// extracted by mini-css-extract-plugin
export default {"goToTopButton":"Gototop_goToTopButton__YqbWX","visible":"Gototop_visible__k9go6","hidden":"Gototop_hidden__cseHo"};